export enum AnswerTypes {
    RADIO,
    NULLABLETEXTBOX
}